import { Component, inject, Input, } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { combineLatest, debounceTime, map, tap } from 'rxjs';
import { PreviewStepsComponent } from 'src/app/features/warp-preview/preview-steps/preview-steps.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DefinitionsInBoardComponent } from '../definitions-in-board/definitions-in-board.component';
import { AnswersStore, StatusValidation } from 'src/app/store/answers-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { WarpQuestionDisplayComponent } from '../warp-question-display/warp-question-display.component';
import { DragStore } from 'src/app/store/drag-store';
import { Question } from 'src/app/models/question.model';

@Component({
    selector: 'que-question-board',
    imports: [CommonModule, WarpQuestionDisplayComponent, PreviewStepsComponent, TranslateDirective, TranslatePipe, DefinitionsInBoardComponent],
    templateUrl: './question-board.component.html',
    styleUrls: ['./question-board.component.scss']
})
export class QuestionBoardComponent {
  @Input() isPreview = false;
  @Input() viewAnswer = false;
  
  #questionnaireStore = inject(QuestionnaireStore);
  #answerStore = inject(AnswersStore);
  #dragStore = inject(DragStore);

  currentStep$ = this.#questionnaireStore.currentStep$;
  currentStepSig$ = toSignal(this.currentStep$);
  currentStepIndex$ = toSignal(this.#questionnaireStore.currentStepIndex$);
  stepsLength$ = this.#questionnaireStore.stepsLength$;
  isUser$ = toSignal(this.#questionnaireStore.isUser$);
  backColor$ = this.#questionnaireStore.backColor$;
  mainColor$ = this.#questionnaireStore.mainColor$;
  invalidCurrentStep$ = this.#answerStore.statusValidationCurrentStep$.pipe(map(s => s === StatusValidation.Error), debounceTime(1));
  isVisitedStep$ = toSignal(combineLatest([this.#answerStore.visitedSteps$, this.#questionnaireStore.currentStepIndex$]).pipe(map(([x, index]) => x.includes(index))))
  isShowError$ = toSignal(this.#answerStore.showIndication$);
  next() {
    if (this.currentStepIndex$() != undefined) {
      this.#answerStore.updateVisitedSteps(this.currentStepIndex$()!);
    }

    this.#questionnaireStore.nextStepIndex();
    this.#dragStore.goToTop(true);
  }
  prev() {
    if (this.currentStepIndex$() != undefined) {
      this.#answerStore.updateVisitedSteps(this.currentStepIndex$()!);
    }
    this.#questionnaireStore.prevStepIndex();
    this.#dragStore.goToTop(true);
  }
  // Without this, *ngFor's default identity check treats every new `step.questions` array
  // emission as all-new items whenever the array is rebuilt (even with the same question ids) -
  // tearing down and recreating que-warp-question-display/que-expense-display mid-edit, which
  // silently drops in-progress validity state (e.g. an unsaved invalid approvedAmount).
  trackByQuestionId(index: number, q: Question): number {
    return q.id;
  }

  getOptionToQuestionById(questionId?: number, optionGuid?: string) {
    if (questionId && optionGuid) {
      var question = this.currentStepSig$()?.questions?.find(q => q?.id == questionId);
      var option = question?.optionsList?.answerOptionItem?.find(op => op.guid == optionGuid);
      return option?.name ?? "";
    }
    return "";
  }
}
